export enum VisibilityTypeProductsListEnum {
  FullyVisible = 0,
  FullyHidden = 1,
  PartiallyVisible = 2
}
